import { render, staticRenderFns } from "./TipoArquivoArrematanteSelect.vue?vue&type=template&id=0bb9412f&"
import script from "./TipoArquivoArrematanteSelect.vue?vue&type=script&lang=js&"
export * from "./TipoArquivoArrematanteSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports